import { useMutation } from '@tanstack/react-query';
import { signOut } from 'firebase/auth';

import { auth } from '@/lib/firebase';

import { useDeleteAuthCookies, useDeleteRefreshCookies } from './auth-cookies';

export const useLogOut = () => {
  const { deleteRefreshCookie } = useDeleteRefreshCookies();
  const { deleteAuthCookie } = useDeleteAuthCookies();

  const signOutMutation = useMutation({
    mutationFn: () => signOut(auth),
  });

  const logout = async () => {
    await deleteRefreshCookie.mutateAsync();
    await deleteAuthCookie.mutateAsync();
    await signOutMutation.mutateAsync();
  };

  return { logout };
};
